// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"header-module--sticky-wrapper--L9nnn","isSticky":"header-module--is-sticky--3NGPO","menuContainer":"header-module--menu-container--1VGx3"};